module.exports = __webpack_public_path__ + "static/media/state-clear_p9.a194388a.png";